export interface CmmdProjectPickerMetadataProps {
  readonly projectId: string;
  readonly teamName: string | null | undefined;
}

export function CmmdProjectPickerMetadata({ projectId, teamName }: CmmdProjectPickerMetadataProps) {
  return (
    <span className="block truncate text-xs text-muted-foreground">
      {teamName ? `${teamName} · ` : null}ID: {projectId}
    </span>
  );
}
